import React from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import Logo from "../assets/Logo.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub, faYoutube, faPaypal } from '@fortawesome/free-brands-svg-icons';

function NavigationBar() {
  return (
    <>
      <Navbar className="bg-body-tertiary" expand="lg">
        <Container>
          <Navbar.Brand href="#home">
            <img
              alt=""
              src={Logo}
              width="30"
              height="30"
              style={{ marginRight: "5px" }}
              className="d-inline-block align-top"
            />{' '}
            Color Shades
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto" style={{ display: "flex", alignItems: "center" }}>
              <Nav.Link href="https://www.linkedin.com/in/rafaelcostaf/" target="_blank">
                <FontAwesomeIcon icon={faLinkedin} size="2x" style={{ margin: "0 10px" }} />
              </Nav.Link>
              <Nav.Link href="https://github.com/RafaelCostaF" target="_blank">
                <FontAwesomeIcon icon={faGithub} size="2x" style={{ margin: "0 10px" }} />
              </Nav.Link>
              <Nav.Link href="https://www.youtube.com/@RafaBRL" target="_blank">
                <FontAwesomeIcon icon={faYoutube} size="2x" style={{ margin: "0 10px" }} />
              </Nav.Link>
            </Nav>

            <Nav className="ml-auto" style={{ display: "flex", alignItems: "center" }}>
              {"Donate 👉"}
              <Nav.Link href="https://www.paypal.com/donate/?hosted_button_id=46SRCSCX8J6X2" target="_blank" style={{ marginLeft: "10px", marginRight:"5px" }}>
                <FontAwesomeIcon icon={faPaypal} size="2x" style={{ marginLeft: "10px" }} />
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default NavigationBar;
